import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles(theme => ({
  background: {    
    display: 'flex',
    height: '80px',    
    alignItems: 'center',
    backgroundImage: 'linear-gradient(30deg, rgba(21, 27, 38, 0.5) 100%, rgba(0, 0, 0, 0) 100%)'
  }
}))